export const CapitalizedFirstLetter = (value: string, field: string) => {
    const stringModify = field == 'select' ? 'select' : 'enter'
    const splitSpace = value?.split(' ')
    const firstIndex = splitSpace[0];
    const firstLetter = firstIndex.charAt(0).toUpperCase()
    const subStringValue = firstIndex.substring(1, firstIndex.length)
    const restValues = ` ${splitSpace.splice(1, splitSpace.length).join(' ')}`
    let firstWord = firstLetter + subStringValue
    const finalValue = firstWord.replaceAll('_', ' ') + restValues
    // return `Please ${stringModify} ${firstWord.replaceAll('_', ' ')}`
    return finalValue
} 